function isRecord(value) {
    return value !== null && typeof value === 'object' && !Array.isArray(value);
}
function optionalString(value) {
    return typeof value === 'string' ? value : undefined;
}
function score(value) {
    return typeof value === 'number' && Number.isFinite(value) && value >= 0 && value <= 1 ? value : undefined;
}
/** Drop unusable words/identity; strip bad optional metadata without changing valid text. */
export function parseCaptionEndpointMessage(value) {
    if (!isRecord(value) || typeof value.message_id !== 'string' || !value.message_id.trim())
        return undefined;
    const type = value.type;
    if (type !== 'transcription-result' && type !== 'translation-result')
        return undefined;
    const first = Array.isArray(value.transcript) && isRecord(value.transcript[0]) ? value.transcript[0] : undefined;
    const text = type === 'translation-result' ? value.text : first?.text;
    if (typeof text !== 'string' || !text.trim())
        return undefined;
    const participant = isRecord(value.participant) ? value.participant : {};
    const timestamp = typeof value.timestamp === 'number' && Number.isFinite(value.timestamp)
        && Math.abs(value.timestamp) <= 8.64e15 ? value.timestamp : undefined;
    const common = {
        captionTone: value.captionTone,
        confidence: score(value.confidence),
        language: optionalString(value.language),
        message_id: value.message_id,
        participant: {
            avatar_url: optionalString(participant.avatar_url),
            id: optionalString(participant.id),
            name: optionalString(participant.name)
        },
        timestamp,
        track: optionalString(value.track)
    };
    if (type === 'translation-result')
        return { ...common, text, type };
    return {
        ...common,
        is_interim: value.is_interim === true,
        stability: score(value.stability) ?? 0,
        transcript: [{ text, confidence: score(first?.confidence) }],
        type
    };
}
